import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')

export const reportsRoutes: RouteRecordRaw[] = [
  {
    path: '/reports',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'reportsTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'reports.occupation' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'occupation',
            name: 'reports.occupation',
            component: () =>
              import('@/modules/Reports/ui/view/dashBoard.vue')
          },
          {
            path: 'monthly-bonuses',
            name: 'reports.monthly.bonuses',
            component: () =>
              import('@/modules/Reports/ui/view/monthlyBonuses.vue')
          }
          
        ]
      }
    ]
  }
]
